<template>
  <div class="form-row" :class="info.dirty && info.invalid?'mb_50':''"
       :style="{background:isMobile && configStyle ? configStyle.formRowBgColor: ''}">
    <div class="form-label" :style="{color:isMobile ? configStyle.formColor: '#353535'}">{{ info.displayName }}</div>
    <div class="form-contro" v-if="isMobile != 1">
      <a-select
        placeholder="请选择"
        @change="info.setValue()"
        v-model="info.model"
        :allowClear="true"
        v-if="info.isCascade !== 1"
        :disabled="info.disabled"
        :style="{background :configStyle && configStyle.formRowBgColor,color:configStyle&&configStyle.formColor}"
      >
        <a-select-option v-for="o in info.listOptions" :key="o.optionValue">
          {{ o.optionValue }}
        </a-select-option>
      </a-select>
      <a-cascader
        v-if="info.isCascade === 1"
        :options="info.listOptions"
        v-model="info.model"
        @change="info.setValue()"
        placeholder="请选择"
        :disabled="info.disabled"
      />
    </div>
    <div class="form-contro form-picker" v-if="isMobile == 1" :style="{ color: configStyle.themeColor }">
      <input
        type="text"
        class="form-input"
        v-model="info.model"
        readonly
        @focus="showAlert()"
        placeholder="请选择"
        :style="{ background: configStyle && configStyle.formRowBgColor,color: configStyle && configStyle.formColor}"
      />
      <span class="icon icontemp down" v-if="!info.value"></span>
      <span
        class="icon icontemp clear"
        v-if="info.value"
        @click="info.clearModel()"
      ></span>
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid && !info.model">
      {{ info.validationMessage }}
    </div>
    <van-popup
      v-model="show"
      position="bottom"
      get-container="body"
      :disabled="info.disabled"
      :style="{ '--my-color': configStyle && configStyle.themeColor }"
    >
      <van-picker
        ref="picker"
        :columns="info.columns"
        :show-toolbar="true"
        @cancel="hideAlert"
        @confirm="vantChange"
        style="--picker-confirm-color: var(--my-color)"
      />
    </van-popup>
  </div>
</template>

<script>
  import { interact } from "fire-wind-water/tools/interact";
  import { $subscriber } from "fire-wind-water/tools/subscriber";
  export default {
    name: "SSelect",
    props: {
      info: {}
    },
    data() {
      return {
        isMobile: false,
        show: false,
        values: [],
        configStyle: null
      };
    },
    methods: {
      vantChange(e) {
        this.show = false;
        this.info.setModel(e);
      },
      showAlert() {
        this.show = true;
        if (this.$refs.picker) {
          this.$refs.picker.setValues(this.info.value || []);
        } else {
          setTimeout(() => {
            this.$refs.picker.setValues(this.info.value || []);
          }, 100);
        }
      },
      hideAlert() {
        this.show = false;
      }
    },
    created() {
      if (interact.isMobile == 1) {
        this.isMobile = true;
      }
      if(this.info.displaySelectType === "RADIO") {
        this.info.columns = [];
        setTimeout(() => {
          this.info.listOptions.forEach(item => {
            this.info.columns.push(item.optionValue);
            this.info.clearModel = function() {
              this.model = undefined;
              this.value = null;
              this.dirty = true;
            };
            this.info.setModel = function(e) {
              this.model = e;
              this.value = e;
              this.dirty = true;
              this.setError();
              if (
                (!this.value || this.value.length === 0) &&
                parseInt(this.required) === 1
              ) {
                this.error.required = true;
              }
            };
          });
        }, 500);
      }
      $subscriber.subscribe("config-style", data=>{
        this.configStyle = data;
      });
    },
    mounted() {}
  };
</script>

<style scoped>
  /deep/.van-picker__confirm {
    color: var(--picker-confirm-color);
  }
  /deep/.van-picker__cancel {
    color: var(--picker-confirm-color);
  }
</style>
